import paddyFieldAreas from "@/api/paddy-field-areas";

export default {
  state: {},
  mutations: {},
  actions: {
    async retrievePaddyFieldAreas(context, management_id = null) {
      try {
        let params;
        if (management_id == null) {
          params = {
            management_id: await context.dispatch("showManagementID"),
          }
        }
        else {
          params = {
            management_id: management_id,
          }
        }
        const response = await paddyFieldAreas.index(params);
        if (response.data && response.data.data) {
          return response.data.data;
        }
        else {
          return [];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};
